/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Button,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import {
  Editor,
  EditorState,
  ContentState,
} from 'draft-js';
import Copy from 'loracoms/Copy';
import Editable from 'loracoms/Editable';
import ShowIf from 'loracoms/ShowIf';
import RichLabel from 'loracoms/RichLabel';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { callAPI } from 'lorautils/api';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { setUrl, setHttpUrl } from '../AppDebug/func/url';
import styles from './styles.scss';


const propTypes = {
  token: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
};

class PullInterfaceRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      token: props.token,
      noteState: EditorState.createEmpty(),
      errors: ErrorSet.createEmpty(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.apiview');
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleEditName = this.handleEditName.bind(this);
    this.handleSubmitName = this.handleSubmitName.bind(this);
    this.handleEditNote = this.handleEditNote.bind(this);
    this.handleChangeNote = this.handleChangeNote.bind(this);
    this.handleSubmitNote = this.handleSubmitNote.bind(this);
    this.handleClickUrl = this.handleClickUrl.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { token } = nextProps;
    if (token !== this.props.token) {
      this.setState({ token });
    }
  }

  handleChangeName(data, id) {
    this.setState({ editData: data });

    const { errors } = this.state;

    if (id === 'name') {
      if (data.name === '') {
        this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      } else {
        this.setState({ errors: errors.remove('name') });
      }
    }
  }

  handleEditName() {
    const { token, editData = {}, errors } = this.state;

    this.setState({
      editName: true,
      editData: {
        ...editData,
        name: token.name,
      },
      errors: errors.remove('name'),
    });
  }

  handleSubmitName() {
    const {
      editData,
      errors,
      token,
    } = this.state;

    if (errors.has('name')) {
      return;
    }
    if (_.trim(editData.name).length === 0) {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
      return;
    }
    callAPI({
      endpoint: `/tokens/${token.token}`,
      body: { name: editData.name },
      method: 'PUT',
    }).then(() => {
      this.setState({
        token: {
          ...token,
          name: editData.name,
          displayName: editData.name,
        },
        editName: false,
      });
    }).catch((error) => {
      this.setState({
        errors: errors.add(error.code, 'name'),
      });
    });
  }

  handleEditNote() {
    const { token } = this.state;
    const { note = '' } = token;
    this.setState({
      noteState: EditorState.createWithContent(ContentState.createFromText(note)),
      editNote: true,
    });
  }

  handleChangeNote(noteState) {
    this.setState({ noteState });
  }

  handleSubmitNote() {
    const { noteState, token } = this.state;
    const note = noteState.getCurrentContent().getPlainText();
    callAPI({
      endpoint: `/tokens/${token.token}`,
      body: { aux: JSON.stringify({ note }) },
      method: 'PUT',
    }).then(() => {
      this.setState({
        token: {
          ...token,
          note,
        },
        editNote: false,
      });
    }).catch(() => {});
  }

  handleClickUrl(url, httpUrl) {
    const { appId, pushState } = this.props;
    setUrl(url);
    setHttpUrl(httpUrl);
    pushState(`/application/${appId}/debug`);
  }

  render() {
    const { onDelete } = this.props;
    const {
      token,
      editName = false,
      editNote = false,
      editData = {},
      noteState,
      errors,
    } = this.state;

    const editTp = <Tooltip id="tooltip-ed">{this.intlMsg.msg('tooltip.edit', 'lora')}</Tooltip>;
    const debugTp = <Tooltip id="tooltip-debug">{this.intlMsg.msg('tooltip.debug')}</Tooltip>;
    const tokenTp = <Tooltip id="tooltip-token">Token</Tooltip>;

    return (
      <div className={`clearfix ${styles.posR} ${styles.noWrap} ${styles.flexContainer}`}>
        <div className={`${styles.flex2}`}>
          <div className={styles.name}>
            <Editable
              id="name"
              edit={editName}
              data={editData}
              value={token.name}
              onChange={this.handleChangeName}
              formatter={() => <span>{token.displayName}</span>}
              error={this.intlMsg.errorMsg(errors.get('name'))}
              errorPlacement={'top'}
            />
            <ShowIf if={!editName}>
              <span className={styles.actions}>
                <OverlayTrigger placement="top" overlay={editTp}>
                  <Link onClick={this.handleEditName} className={styles.edit}>
                    <span className="halflings halflings-pencil" />
                  </Link>
                </OverlayTrigger>
              </span>
            </ShowIf>
            <ShowIf if={editName}>
              <span className={styles.actions}>
                <Link onClick={this.handleSubmitName} className={styles.ok}>
                  <span className="halflings halflings-ok" />
                </Link>
                <Link onClick={() => this.setState({ editName: false })} className={styles.cancel}>
                  <span className="halflings halflings-remove" />
                </Link>
              </span>
            </ShowIf>
          </div>

          <div className={styles.token}>
            <OverlayTrigger placement="top" overlay={tokenTp}>
              <span className="halflings halflings-key" />
            </OverlayTrigger>
            {' '}{token.token}{' '}
            <Copy id={`copy-token-${token.token}`} text={token.token} />
          </div>

          <div className={styles.note}>
            <Editable
              id="note"
              edit={editNote}
              value={token.note}
              formatter={(x) => {
                if (x === '' || _.isNil(x)) {
                  return <Link onClick={this.handleEditNote}>{this.intlMsg.msg('noteedit.link')}</Link>;
                }
                return <span>{x}</span>;
              }}
              onChange={this.handleChangeName}
              control={{
                type: 'external',
                external: (
                  <Editor
                    editorState={noteState}
                    onChange={this.handleChangeNote}
                  />
                ),
              }}
            />
            <ShowIf if={!editNote && token.note !== '' && !_.isNil(token.note)}>
              <span className={styles.actions}>
                <OverlayTrigger placement="top" overlay={editTp}>
                  <Link onClick={this.handleEditNote}>
                    <span className="halflings halflings-pencil" />
                  </Link>
                </OverlayTrigger>
              </span>
            </ShowIf>
            <ShowIf if={editNote}>
              <div className={styles.actions}>
                <Link onClick={this.handleSubmitNote} className={styles.ok}>
                  <span className="halflings halflings-ok" />
                </Link>
                <Link onClick={() => this.setState({ editNote: false })} className={styles.cancel}>
                  <span className="halflings halflings-remove" />
                </Link>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className={`${styles.url} ${styles.flex2}`}>
          <RichLabel content="WebSocket" />
          <div className={styles.tools}>
            <OverlayTrigger placement="top" overlay={debugTp}>
              <Link onClick={() => this.handleClickUrl(token.wsurl, token.httpurl)}>
                <span className="halflings halflings-wrench" />
              </Link>
            </OverlayTrigger>
            {' '}
            <Copy id={`copy-wsurl-${token.token}`} text={token.wsurl} />
          </div>
          <div className={styles.urlLink}>{token.wsurl}</div>
        </div>
        <div className={`${styles.url} ${styles.flex2} ${styles.borderRight}`}>
          <RichLabel content="HTTP" />
          <div className={styles.tools}>
            <OverlayTrigger placement="top" overlay={debugTp}>
              <Link onClick={() => this.handleClickUrl(token.httpurl, token.httpurl)}>
                <span className="halflings halflings-wrench" />
              </Link>
            </OverlayTrigger>
            {' '}
            <Copy id={`copy-httpurl-${token.token}`} text={token.httpurl} />
          </div>
          <div className={styles.urlLink}>{token.httpurl}</div>
        </div>
        <div className={`${styles.delete} ${styles.flex1}`}>
          <Button
            bsStyle="aisz-link-danger"
            onClick={onDelete}
            className={styles.deleteBtn}
          >
            <span className="glyphicons glyphicons-bin" />
            <br />
            {this.intlMsg.msg('apidel.btn')}
          </Button>
        </div>
      </div>
    );
  }
}

PullInterfaceRow.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(PullInterfaceRow));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/PullInterfaceRow/index.jsx